module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Update-50e05650cce427357543c605d326694a.svg";